// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class InvoiceInvoicingProduct extends Model {
    static table = 'invoice_invoicing_products';

    static associations = {
        invoices: { type: 'belongs_to', key: 'invoice_id' },
        invoicing_products: { type: 'belongs_to', key: 'invoicing_product_id' },
    };

    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @field('invoice_id') invoiceId;
    @field('invoicing_product_id') invoicingProductId;
    @field('quantity') quantity;
    @field('name') name;
    @field('price') price;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
}

export type InvoiceInvoicingProductSimple = {
    id: string;
    userId: string;
    organisationId: string;
    invoiceId: string;
    invoicingProductId: string;
    quantity: number;
    name: string;
    price: string;
    createdAt: string;
    updatedAt: string;
};

export function simplifyInvoiceInvoicingProduct(
    invoiceInvoicingProduct: InvoiceInvoicingProductModel,
): InvoiceInvoicingProductSimple {
    return {
        id: invoiceInvoicingProduct.id,
        name: invoiceInvoicingProduct.name,
        price: invoiceInvoicingProduct.price,
        quantity: invoiceInvoicingProduct.quantity,
        invoiceId: invoiceInvoicingProduct.invoiceId,
        invoicingProductId: invoiceInvoicingProduct.invoicingProductId,
        userId: invoiceInvoicingProduct.userId,
        organisationId: invoiceInvoicingProduct.organisationId,
        createdAt: invoiceInvoicingProduct.createdAt.toISOString(),
        updatedAt: invoiceInvoicingProduct.updatedAt.toISOString(),
    };
}
